import React, { useState, useEffect, useMemo } from "react"
import { Row, Col, Card, Table, Input } from "reactstrap"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import Loader from "pages/Separate/Loader"
import axios from "axios"
import Select from "react-select"
import configure from "configure"
import { DatePicker } from "antd"
import NewPagination from "components/Common/Newpagination"
import { SixMonsLeaveColumn } from "utils/columns/Human Resource/SixMonsLeaveColumn"
import { useSelector } from "react-redux"
import { colourStyles } from "utils/common-options"
const { RangePicker } = DatePicker

function TableContainer({
  columns,
  data,
  totalLeaves,
  fromDate,
  toDate,
  setFromDate,
  toggleLoading,
  setToDate,
  fetchAdminData,
}) {
  // Normalize data to ensure it's an array
  const normalizedData = Array.isArray(data) ? data : []
  const generalData = useSelector(state => state?.GeneralData?.generalData)

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
  } = useTable(
    {
      columns,
      data: normalizedData,
      initialState: {
        sortBy: [{ id: "year", desc: true }],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize } = state

  useEffect(() => {
    setPageSize(10) // Now setPageSize is from useTable
  }, [setPageSize])

  const [members, setMembers] = useState(null)

  const handleFilter = () => {
    fetchAdminData(members?.value || null, fromDate, toDate)
  }
  return (
    <Row>
      <Col xl="12">
        <div className="card-body">
          <Row className="align-items-center justify-content-between mb-3">
            <Col md="auto" className="text-purple fs-5 fw-bold">
              Past Six Month Leaves
            </Col>

            <Col
              md="auto"
              className="d-flex align-items-center justify-content-end gap-3"
            >
              {localStorage?.getItem("auth_id") == 1 ||
              localStorage?.getItem("auth_id") == 32 ||
              localStorage?.getItem("auth_id") == 4 ||
              localStorage?.getItem("auth_id") == 46 ? (
                <div className="d-flex align-items-center gap-2 flex-nowrap">
                  <div style={{ minWidth: "200px", maxWidth: "500px" }}>
                    <Select
                      placeholder="Select Member"
                      className="basic-single-select"
                      classNamePrefix="select"
                      styles={colourStyles}
                      options={generalData?.staff}
                      value={members}
                      onChange={selectedOption => setMembers(selectedOption)}
                      id="member-select"
                    />
                  </div>
                  <RangePicker
                    picker="month"
                    value={[fromDate, toDate]}
                    onChange={dates => {
                      if (dates) {
                        setFromDate(dates[0])
                        setToDate(dates[1])
                      } else {
                        setFromDate(null)
                        setToDate(null)
                      }
                    }}
                    format="YYYY-MM"
                  />
                  <a
                    className="btn btn-sm me-1 bg-purple text-white"
                    style={{ borderRadius: "5px" }}
                    onClick={handleFilter}
                  >
                    <i className="bi bi-funnel-fill fs-5"></i>
                  </a>
                </div>
              ) : null}
              <div className="text-purple absent-length">{totalLeaves}</div>
            </Col>
          </Row>

          <div className="table-responsive">
            <Table className="table table-bordered" {...getTableProps()}>
              <thead>
                {headerGroups.map((headerGroup, i) => (
                  <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => (
                      <th
                        key={index}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className="text-center"
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row)
                  return (
                    <tr
                      key={i}
                      {...row.getRowProps()}
                      style={{
                        backgroundColor:
                          row.original.leaves > 4
                            ? "#fff3f3" // red-ish
                            : row.original.leaves > 2
                            ? "#ffe8bf52" // orange-ish
                            : "transparent",
                      }}
                    >
                      {row.cells.map((cell, index) => (
                        <td
                          key={index}
                          {...cell.getCellProps()}
                          className="text-center"
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>

          <Row className="d-flex justify-content-between align-items-center flex-wrap py-3 py-md-0">
            <NewPagination
              gotoPage={gotoPage}
              canPreviousPage={canPreviousPage}
              previousPage={previousPage}
              canNextPage={canNextPage}
              pageIndex={pageIndex}
              pageOptions={pageOptions}
              pageSize={pageSize}
              page={page}
              data={normalizedData}
              nextPage={nextPage}
            />
          </Row>
        </div>
      </Col>
    </Row>
  )
}

const PastLeaves = () => {
  const [isLoading, setLoading] = useState(false)
  const [modal_Access, setAccessDenied] = useState(false)
  const [data, setData] = useState([])
  const [totalLeaves, setTotalLeaves] = useState(0)
  const [toDate, setToDate] = useState("")
  const [fromDate, setFromDate] = useState("")
  const [members, setMembers] = useState(null) // Single select

  const fetchNodeData = async (memberId = null, fromDate = "", toDate = "") => {
    setLoading(true)
    const user_id = localStorage.getItem("auth_id")
    try {
      let response
      if (!memberId && !fromDate && !toDate) {
        response = await axios.get(
          `${configure.nodeApi}/pastLeaves/${user_id}`,
          { params: { type: 0 }, timeout: 10000 }
        )
      } else {
        const payload = { type: 0 }
        if (memberId) payload.memberId = memberId
        if (fromDate) payload.fromDate = fromDate
        if (toDate) payload.toDate = toDate
        response = await axios.post(
          `${configure.nodeApi}/adminLeaveCount`,
          payload,
          {
            headers: { "Content-Type": "application/json" },
            timeout: 10000,
          }
        )
      }
      // Normalize response.data.data to an array
      const responseData = Array.isArray(response.data?.data)
        ? response.data.data
        : []
      setTotalLeaves(response.data?.totalLeavesInSixMonths || 0)
      setData(responseData)
    } catch (error) {
      console.error("Error details:", error.response?.data || error.message)
      setAccessDenied(true)
      setData([]) // Reset to empty array on error
    } finally {
      setLoading(false)
    }
  }

  const fetchAdminData = async (
    memberId = null,
    fromDate = "",
    toDate = ""
  ) => {
    setLoading(true)
    const user_id = localStorage.getItem("auth_id")
    try {
      const payload = { type: 0 }
      if (memberId) payload.memberId = memberId
      if (fromDate) payload.fromDate = fromDate
      if (toDate) payload.toDate = toDate

      const response = await axios.post(
        `${configure.nodeApi}/adminLeaveCount/${memberId}`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
          timeout: 10000,
        }
      )
      // Normalize response.data.data to an array
      const responseData = Array.isArray(response.data?.data)
        ? response.data.data
        : []
      setTotalLeaves(response.data?.totalLeavesInRange || 0)
      setData(responseData)
    } catch (error) {
      setAccessDenied(true)
      setData([]) // Reset to empty array on error
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchNodeData() // Initial fetch with default params (uses axios.get)
  }, [])

  const column1 = useMemo(() => SixMonsLeaveColumn(), [])

  return (
    <div>
      {isLoading && <Loader />}
      <div className="position-relative">
        <Row>
          <Col lg="12">
            <Card>
              <div className="responsive-table">
                <TableContainer
                  columns={column1}
                  data={data}
                  totalLeaves={totalLeaves}
                  members={members}
                  setMembers={setMembers}
                  fromDate={fromDate}
                  setFromDate={setFromDate}
                  toDate={toDate}
                  setToDate={setToDate}
                  toggleLoading={setLoading}
                  fetchAdminData={fetchAdminData}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default PastLeaves
